import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import RentRobotlistPSN from "../../components/robot/RentRobotlistPSN";

const { Content } = Layout;

function RentRobotPSN({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <RentRobotlistPSN />
            </Content>
         </Layout>
      </Layout>
   );
}

export default RentRobotPSN;
